import React__default from 'react';
import { FormFieldWrap, Select, P3 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import useAdobeUtils from '../../../hooks/useAdobe.js';
import styles from './DeliveryInterval.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const DeliveryInterval = (props) => {
    const { site } = useSiteContext();
    const { trackIntervalChanged } = useAdobeUtils();
    const { t } = useTranslation(site.realm);
    const onIntervalChanged = (e) => {
        const newInterval = e.target.value;
        if (newInterval !== props.defaultInterval)
            trackIntervalChanged(newInterval * 7);
        props.setSelectedInterval(newInterval);
    };
    return (React__default.createElement(FormFieldWrap, { className: styles.wrapper, labelText: t('checkout.common.delivery-interval-new.title'), errorMessage: props.checkIntervalSelected && !props.defaultInterval ? t('checkout.common.delivery-interval-new.error') : undefined },
        React__default.createElement(Select, { "data-testid": "autoshipmentIntervalSelector", onChange: onIntervalChanged, hasError: props.checkIntervalSelected && !props.defaultInterval },
            !props.defaultInterval && React__default.createElement("option", null, t('checkout.common.delivery-interval-new.no-selected-interval')),
            props.options.map((interval) => (React__default.createElement("option", { id: interval.toString(), key: interval, selected: interval === props.defaultInterval, value: interval }, t(interval == 1
                ? 'checkout.common.delivery-interval-new.week-interval_one'
                : 'checkout.common.delivery-interval-new.week-interval_other', { postProcess: 'interval', count: interval }))))),
        !props.checkIntervalSelected && props.defaultInterval != 0 && React__default.createElement(P3, { className: styles.info }, t('checkout.cart-offer.interval-info'))));
};

export { DeliveryInterval };
//# sourceMappingURL=DeliveryInterval.js.map
